import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./auth";
import admin from "./admin";
import tenant from "./tenant";
import learner from "./learner";
import shared from "./shared";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    admin,
    tenant,
    learner,
    shared,
  },
  plugins: [
    createPersistedState({
      //key: "lms-app",
      key: "edclearn-storage",
      overwrite: true,
      storage: window.sessionStorage,
      //default is localStorage
    }),
  ],
});
